export default __webpack_public_path__ + "static/media/slider-dummy.2ba55550.png";